import { render, staticRenderFns } from "./EditproductgroupPage.vue?vue&type=template&id=356e6a80"
import script from "./EditproductgroupPage.vue?vue&type=script&lang=js"
export * from "./EditproductgroupPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports